import React from 'react'
import moment from 'moment'

const DateTimeGenericComponent = ({ data, attribute }) => {
    const date = data && data[attribute.name] ? data[attribute.name] : null
    return <>{!date ? '-' : moment.utc(date).local().format('L LT')}</>
}
export default DateTimeGenericComponent
